import { Injectable } from "@angular/core";
import { BestoranteService } from "./bestorante";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root"
})
export class GuestModeService {

  constructor(private besto: BestoranteService, private storage: StorageService) { }

  saveGuestDetails(guestDetails) {
    this.besto.restaurant = guestDetails;
    this.storage.set("guestDetails", guestDetails);
  }
}
